import vm from "../main";
import axios from "./PointrCloudAxios";
import ToastHelpers from "@/helpers/ToastHelpers";

export default class BuildingService {
  static async getBuildings(clientInternalIdentifier, siteInternalIdentifier) {
    let response;
    let buildings;
    vm.$store.commit("ADD_LOADING_REQUEST");
    try {
      response = await axios.get(
        `/content/draft/clients/${clientInternalIdentifier}/sites/${siteInternalIdentifier}/buildings`
      );
    } catch (error) {
      console.error(error);
    } finally {
      vm.$store.commit("REMOVE_LOADING_REQUEST");
    }
    const geojson = response?.data;
    if (geojson) {
      buildings = geojson?.features?.filter((feature) => feature.properties.typeCode === "building-outline");
      buildings = buildings.map((building, index) => {
        building.properties.levels = geojson?.features?.filter(
          (feature) =>
            feature.properties.typeCode === "level-outline" && feature.properties.bid === building.properties.fid
        );
        building.properties.mapId = index;
        return building;
      });
      buildings = buildings.map((building) => {
        building.properties.levels.sort((a, b) => a.properties.lvl - b.properties.lvl);
        return building;
      });
      buildings.sort((a, b) => {
        if (a.properties.name < b.properties.name) return -1;
        if (a.properties.name > b.properties.name) return 1;
        return 0;
      });
      // sort buildings by name
      return buildings;
    }
    return undefined;
  }

  static async getBuilding(clientInternalIdentifier, siteInternalIdentifier, buildingInternalIdentifier) {
    let response;
    let buildings;
    vm.$store.commit("ADD_LOADING_REQUEST");
    try {
      response = await axios.get(
        `/content/draft/clients/${clientInternalIdentifier}/sites/${siteInternalIdentifier}/buildings/${buildingInternalIdentifier}`
      );
    } catch (error) {
      console.error(error);
    } finally {
      vm.$store.commit("REMOVE_LOADING_REQUEST");
    }
    const geojson = response?.data;
    if (geojson) {
      buildings = geojson?.features?.filter((feature) => feature.properties.typeCode === "building-outline");
      buildings = buildings.map((building) => {
        building.properties.levels = geojson?.features?.filter(
          (feature) =>
            feature.properties.typeCode === "level-outline" && feature.properties.bid === building.properties.fid
        );
        return building;
      });
      // sort buildings by name
      return buildings[0];
    }
    return undefined;
  }

  static async createBuilding(request, clientIdentifier, siteInternalIdentifier) {
    let response;
    vm.$store.commit("ADD_LOADING_REQUEST");
    try {
      response = await axios.post(
        `/content/draft/clients/${clientIdentifier}/sites/${siteInternalIdentifier}/buildings`,
        request
      );
    } catch (error) {
      console.error(error);
      ToastHelpers.createServiceErrorToast(
        error?.response?.data,
        error?.response?.data?.message || `${vm.$t("contents.fail-message")}`
      );
      return error?.response?.data;
    } finally {
      vm.$store.commit("REMOVE_LOADING_REQUEST");
    }
    // ToastHelpers.createSuccessToast(`Building ${vm.$t("contents.created")}`);
    return response?.data;
  }

  static async updateBuilding(payload, clientInternalIdentifier, siteInternalIdentifier, buildingInternalIdentifier) {
    let response;
    vm.$store.commit("ADD_LOADING_REQUEST");
    try {
      response = await axios.put(
        `/content/draft/clients/${clientInternalIdentifier}/sites/${siteInternalIdentifier}/buildings/${buildingInternalIdentifier}`,
        payload
      );
    } catch (error) {
      console.error(error);
      ToastHelpers.createServiceErrorToast(
        error?.response?.data,
        error?.response?.data?.message || `${vm.$t("contents.fail-message")}`
      );
      return error?.response?.data;
    } finally {
      vm.$store.commit("REMOVE_LOADING_REQUEST");
    }
    // ToastHelpers.createSuccessToast(`${payload.features[0].properties.name} ${vm.$t("contents.updated")}`);
    return response?.data;
  }

  static async deleteBuilding(clientInternalIdentifier, siteInternalIdentifier, buildingInternalIdentifier) {
    let response;
    vm.$store.commit("ADD_LOADING_REQUEST");
    try {
      response = await axios.delete(
        `/content/draft/clients/${clientInternalIdentifier}/sites/${siteInternalIdentifier}/buildings/${buildingInternalIdentifier}`
      );
    } catch (error) {
      console.error(error);
      ToastHelpers.createServiceErrorToast(
        error?.response?.data,
        error?.response?.data?.message || vm.$t(`delete-failed`)
      );
      return error?.response?.data;
    } finally {
      vm.$store.commit("REMOVE_LOADING_REQUEST");
    }
    ToastHelpers.createSuccessToast(`Building ${vm.$t("delete-success")}`);
    return response?.data;
  }

  static async addOrUpdateFeaturesOfBuilding(
    clientInternalIdentifier,
    siteInternalIdentifier,
    buildingInternalIdentifier,
    features
  ) {
    let response;
    vm.$store.commit("ADD_LOADING_REQUEST");
    try {
      response = await axios.post(
        `/content/draft/clients/${clientInternalIdentifier}/sites/${siteInternalIdentifier}/buildings/${buildingInternalIdentifier}/features`,
        features
      );
    } catch (error) {
      console.error(error);
      ToastHelpers.createServiceErrorToast(
        error?.response?.data,
        error?.response?.data?.message || vm.$t(`timeout-error`)
      );
      return;
    } finally {
      vm.$store.commit("REMOVE_LOADING_REQUEST");
    }
    return response?.data;
  }

  static async getAllDraftFeaturesOfBuilding(
    clientInternalIdentifier,
    siteInternalIdentifier,
    buildingInternalIdentifier,
    abortSignal
  ) {
    let response;
    try {
      response = await axios.get(
        `/content/draft/clients/${clientInternalIdentifier}/sites/${siteInternalIdentifier}/buildings/${buildingInternalIdentifier}/features`,
        abortSignal ? { signal: abortSignal } : {}
      );
    } catch (error) {
      console.error(error);
      throw error;
    }
    return response?.data;
  }
}
